import { Link } from 'react-router-dom'
import { Button, InlineAlert } from '../components/BaseComponents'
import { FormEvent, useState } from 'react';
import useApi from '../hooks/useApi';
import { FORM_INPUT_TEXT_CLASS, FORM_LABEL_CLASS } from '../lib/formStyles';
import { INPUT_FOCUS_RING, TEXT_LINK_FOCUS_RING } from '../lib/a11yFocus';
import { getCSRFToken } from '../lib/utils';
import routes from '../components/Router/routes';

function ForgotPassword() {
    const api = useApi();

    const [submitting, setSubmitting] = useState(false);
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const onFormSubmit = (e: FormEvent) => {
       e.preventDefault();
       onSubmit();
       return false; 
    }

    const onSubmit = async () => {
        setSubmitting(true)
        setError('');
        setMessage('');

        try {
            const result = await api.post('/user/sendResetEmail', {
                email,
                _csrf: await getCSRFToken(),
            });

            setSubmitting(false);

            setMessage(result.message)
            
        } catch(error: any) {
            setSubmitting(false);
            if(error.body?.error) {
                setError(error.body.error)
            } else {
                setError('An unknown error occured');
            }
        }
    }

    return (
        <div className="content w-full max-w-[32rem] px-4 sm:px-0 mx-auto mt-16 mb-8">
            <div className="text-charcoal-100 text-2xl text-center">Forgot your password?</div>
            <form onSubmit={onFormSubmit}>
                <label className="block mt-8 text-sm">
                    <span className={FORM_LABEL_CLASS}>Enter your email address</span>
                    <br />
                    <input
                        disabled={submitting}
                        name="email"
                        className={`rounded w-full mt-1 ${FORM_INPUT_TEXT_CLASS} ${INPUT_FOCUS_RING}`}
                        type="text"
                        placeholder="you@example.com"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                </label>
                <div className='mt-6 flex justify-start'>
                    <Button
                        disabled={submitting}
                        buttonType="submit"
                        type="Primary"
                        text="Reset password"
                        context="form-field"
                    />
                </div>

                <div className="mt-6">
                    <span className="text-charcoal-100">Remember your password? </span>
                    <Link
                        className={`underline text-algae-500 ${TEXT_LINK_FOCUS_RING}`}
                        to={routes.publicLogin.path}
                    >
                        Log in
                    </Link>
                </div>
                <div className="mt-2">
                    <span className="text-charcoal-100">Don't have an account? </span>
                    <Link
                        className={`underline text-algae-500 ${TEXT_LINK_FOCUS_RING}`}
                        to={routes.publicSignUp.path}
                    >
                        Sign up
                    </Link>
                </div>
            </form>
            { error && (
                <InlineAlert type='error' className='mt-6'>{ error }</InlineAlert>
            )}
            { message && (
                <InlineAlert type='success' className='mt-6'>{ message }</InlineAlert>
            )}
        </div>
    );
}

export default ForgotPassword
